import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  entityIntegranteAdapter,
  EntityIntegranteState
} from './entity-integrante.state';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { selectAllRol } from '../entity-roles/entity-roles.selectors';
import { selectAllPersonas } from '../../persona/entity-personas/entity-personas.selectors';
import { createIntegrante, Integrante } from '../integrante/integrante.model';

const { selectEntities, selectAll } = entityIntegranteAdapter.getSelectors();

export const getError = (state: EntityIntegranteState): any => state.error;

export const getIsLoading = (state: EntityIntegranteState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntityIntegranteState): boolean =>
  state.hasAddedSuccess;

export const selectIntegranteState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.integrantes
);

export const selectAllIntegrante = createSelector(
  selectIntegranteState,
  selectAll
);
export const selectEntitiesIntegrante = createSelector(
  selectIntegranteState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectIntegranteError = createSelector(
  selectIntegranteState,
  getError
);

// MemoizedSelector<object,any>
export const selectIntegranteIsLoading = createSelector(
  selectIntegranteState,
  getIsLoading
);

export const selectIntegranteAddedSuccess = createSelector(
  selectIntegranteState,
  getHasAddedSuccess
);

export const selectIntegrantesCurrentEmpresa = createSelector(
  selectCurrentEmpresa,
  selectAllRol,
  selectAllPersonas,
  (ce, roles, personas) => {
    let integrantes: Integrante[] = [];
    if (ce && roles && personas) {
      const rolesCurrentEmpresa = roles.filter(
        (r) => r.entidad_productiva_id == ce.id && r.vinculo_aprobado_entidad_productiva
      );
      rolesCurrentEmpresa.forEach((r) => {
        const persona = personas.find((p) => p.id == r.persona_id);
        const integrante = createIntegrante({
          rol: r,
          nombre_completo: persona?.nombre_completo || '',
          documento_persona: persona?.documentos_persona[0] || '',
          correo_electronico: persona?.correo_electronico.direccion || '',
          // TODO
          cv: null,
          laboratorios_id: null,
          actividades_id: null,
          persona: persona
        });
        integrantes.push(integrante);
      });
    }
    return integrantes;
  }
);
